import { RentStage } from '@tallo/property';

export enum ApplicationsFilter {
  ALL = 'All',
  INVITED = 'Invited to apply',
  IN_PROGRESS = 'In progress',
  PENDING = 'Waiting for review',
  ACCEPTED = 'Accepted',
  REJECTED = 'Rejected',
}

export const applicationsFilterStages = new Map<ApplicationsFilter, RentStage[]>([
  [
    ApplicationsFilter.ALL,
    [
      RentStage.APPLICATION_INVITE_SENT,
      RentStage.APPLICATION_ACCEPTED,
      RentStage.APPLICATION_REJECTED,
      RentStage.APPLICATION_COMPLETED,
      RentStage.APPLICATION_IN_PROGRESS,
    ],
  ],
  [ApplicationsFilter.INVITED, [RentStage.APPLICATION_INVITE_SENT]],
  [ApplicationsFilter.IN_PROGRESS, [RentStage.APPLICATION_IN_PROGRESS]],
  [ApplicationsFilter.PENDING, [RentStage.APPLICATION_COMPLETED]],
  [ApplicationsFilter.ACCEPTED, [RentStage.APPLICATION_ACCEPTED]],
  [ApplicationsFilter.REJECTED, [RentStage.APPLICATION_REJECTED]],
]);
